import colors from "vuetify/es5/util/colors";

function mapCategoryCodeToHexColor(categoryCode) {
  const map = [
    {
      code: "pol",
      color: colors.green.base
    },
    {
      code: "eco",
      color: colors.lightGreen.base
    },
    {
      code: "pan",
      color: colors.lime.base
    },
    {
      code: "sci",
      color: colors.yellow.base
    },
    {
      code: "med",
      color: colors.amber.base
    },
    {
      code: "cul",
      color: colors.orange.base
    },
    {
      code: "spo",
      color: colors.deepOrange.base
    },
    // WIP-Visual: Non-functional filters
    {
      code: "!spo",
      color: colors.red.base
    },
    {
      code: "net",
      color: colors.pink.base
    },
    {
      code: "tmn",
      color: colors.purple.base
    }
  ];

  const found = map.find(item => item.code === categoryCode);

  return found ? found.color : "";
}

export default mapCategoryCodeToHexColor;
